import { createHashHistory, History } from 'history';

let history: History;

export function getHistory() {
	history ??= createHashHistory();
	return history;
}
